// The icons of the two keys of the top bar on the phone, where the words do
// not fit. Added 2026-10-13, from a design pass. Garrett: "do we need a
// hamburger menu at the top? or just icons too for log/menu?" The log is a
// clock with an arrow that turns back, because the log is also the history.
// The menu is three bars. Surrender is a flag on a pole, added 2026-10-15.
// The drawings are placeholders.

import { svg } from '../lib/svg';

const ICON_BOX = 24;

const ICON_PATHS = {
  log: ['M4.5 12a7.5 7.5 0 1 0 2.3-5.4', 'M4 4.5v3.5h3.5', 'M12 8v4.5l3 2'],
  menu: ['M4 6.5h16', 'M4 12h16', 'M4 17.5h16'],
  surrender: ['M6 21V3.5', 'M6 4.5h12l-3 4.25 3 4.25H6'],
} as const;

export type TopBarIcon = keyof typeof ICON_PATHS;

/** A line drawing in the color of the text of its key. */
export const createTopBarIcon = (icon: TopBarIcon): SVGSVGElement =>
  svg(
    'svg',
    { class: 'topbar__icon', viewBox: `0 0 ${ICON_BOX} ${ICON_BOX}`, 'aria-hidden': 'true' },
    ICON_PATHS[icon].map((d) => svg('path', { d })),
  );
